// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserComment_wrapper___B751","userName":"UserComment_userName__BRJrw"};